
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class NavHeader extends Vue {
  @Prop({default: false})
  public showLinkback!: boolean;
  public collapsed = false;
}
